import React from 'react';
import {
  Paper,
  FormWrapper,
  Col,
  Row,
  RFFormInput,
  RFFormSelect,
  ButtonWithLoader,
  ButtonsContainer,
} from 'virtues-bootstrap';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import AdaptiveDataRow from 'components/DataBlock/AdaptiveDataRow';
import DetailedEPReportFrom from 'components/DetailedEPReport/From';
import DeviceInformationForm from 'components/DeviceInformation/components/Form';

import FileInput from './FileInput';

import s from './styles.module.scss';

const titleSizes = {
  xs: 3,
};

const contentSizes = {
  xs: 9,
  lg: 6,
};

const TransmissionReportSummary = ({
  t,
  handleSubmit,
  deviceVendor,
  doctors,
  submitting,
  pristine,
  alert,
  shockNa,
  transmissionType,
  unscheduledVisitReason,
  onChangeShockCheckbox,
}) => (
  <form onSubmit={handleSubmit}>
    <Paper>
      <FormWrapper title={t('reports.deviceTransmissionReport')}>
        <AdaptiveDataRow
          withLabelMargin
          titleSizes={titleSizes}
          contentSizes={contentSizes}
          title={t('reports.deviceVendor')}
        >
          <div className={s.textValue}>{deviceVendor}</div>
        </AdaptiveDataRow>
        <AdaptiveDataRow
          withLabelMargin
          titleSizes={titleSizes}
          contentSizes={contentSizes}
          title={t('reports.transmissionType')}
        >
          <div className={s.textValue}>{transmissionType}</div>
        </AdaptiveDataRow>
        {unscheduledVisitReason && (
          <AdaptiveDataRow
            withLabelMargin
            titleSizes={titleSizes}
            contentSizes={contentSizes}
            title={t('reports.unscheduledVisitReason')}
          >
            <div className={s.textValue}>{unscheduledVisitReason}</div>
          </AdaptiveDataRow>
        )}
        <AdaptiveDataRow
          withLabelMargin
          titleSizes={titleSizes}
          contentSizes={contentSizes}
          title={t('reports.sentOn')}
        >
          <Row>
            <Col xs={7}>
              <Field
                className={s.fieldWithoutMargin}
                component={RFFormInput}
                name="sentOnDate"
                placeholder="MM/DD/YYYY"
              />
            </Col>
            <Col xs={5}>
              <Field
                className={s.fieldWithoutMargin}
                component={RFFormInput}
                name="sentOnHour"
                placeholder="HH:mm"
              />
            </Col>
          </Row>
        </AdaptiveDataRow>

        <AdaptiveDataRow
          withLabelMargin
          titleSizes={titleSizes}
          contentSizes={contentSizes}
          title={t('reports.doctor')}
        >
          <Field
            className={s.fieldWithoutMargin}
            placeholder={t('reports.chooseDoctor')}
            component={RFFormSelect}
            name="doctor"
          >
            {doctors.map(({ reference, display }) => (
              <option key={reference} value={reference}>
                {display}
              </option>
            ))}
          </Field>
        </AdaptiveDataRow>
        <AdaptiveDataRow
          withLabelMargin
          titleSizes={titleSizes}
          contentSizes={contentSizes}
          title={t('reports.deviceClinicEmail')}
        >
          <Field
            placeholder="deviceclinic@email.com"
            className={s.fieldWithoutMargin}
            component={RFFormInput}
            name="deviceClinicEmail"
          />
        </AdaptiveDataRow>
        <AdaptiveDataRow
          withLabelMargin
          titleSizes={titleSizes}
          contentSizes={contentSizes}
          title={t('reports.additionalDocuments')}
        >
          <Field type="file" name="additionalDocuments" component={FileInput} />
        </AdaptiveDataRow>
      </FormWrapper>

      <FormWrapper title={t('reports.deviceInformation')}>
        <DeviceInformationForm
          alert={alert}
          onChangeShockCheckbox={onChangeShockCheckbox}
          shockNa={shockNa}
        />
      </FormWrapper>

      <DetailedEPReportFrom />

      <ButtonsContainer className={s.saveBtn}>
        <ButtonWithLoader
          id="submitToClinician"
          type="submit"
          disabled={submitting || pristine}
          loading={submitting}
        >
          {t('reports.submitToClinician')}
        </ButtonWithLoader>
      </ButtonsContainer>
    </Paper>
  </form>
);

TransmissionReportSummary.propTypes = {
  t: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  deviceVendor: PropTypes.string.isRequired,
  submitting: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  doctors: PropTypes.arrayOf(PropTypes.object).isRequired,
  alert: PropTypes.bool,
  shockNa: PropTypes.bool.isRequired,
  transmissionType: PropTypes.string.isRequired,
  unscheduledVisitReason: PropTypes.string,
  onChangeShockCheckbox: PropTypes.func.isRequired,
};

TransmissionReportSummary.defaultProps = {
  alert: false,
  unscheduledVisitReason: null,
};

export default TransmissionReportSummary;
